import { tags as junctionTags } from "./_init/_junction.tags";
import { tags as gradingTags } from "./_init/_grading.tags";
import { tags as activityTags } from "./_init/_activity.tags";
import { tags as reorderTags } from "./_init/_reorder.tags";
import { tags as rubricTags } from "./_init/_rubrics.tags";
import { tags as lwmTags } from "./_init/_lwm.tags";
import { tags as lmsTags } from "./_init/_lms.tags";
import { tags as ltiTags } from "./_init/_lti.tags";
import { tags as aiTags } from "./_init/_ai.tags";
import { tags as ddTags } from "./_init/_dd.tags";
import { tags as enrollmentTags } from "./_init/_enrollments.tags";
import { tags as panelsTags } from "./_init/_panels.tags";
import { tags as programsTags } from "./_init/_programs.tags";
import { tags as adminTags } from "./_init/_admin.tags";
import { tags as flashcardsTags } from "./_init/_flashcards.tags";
import { tags as assessmentTags } from "./_init/_assessment.tags";
import { tags as loginTags } from "./_init/_login.tags";
import { tags as pluginTags } from "./_init/_plugin.tags";

export function loadEagerComponents() {
  return Promise.all([import("./_init/_initial"), import("./_init/_design")]);
}

/**
 * Check out the readme for instructions about adding new chunks.
 */

export function loadComponentsLazily() {
  loadComponentModuleLazily(junctionTags, () => import("./_init/_junction"));
  loadComponentModuleLazily(gradingTags, () => import("./_init/_grading"));
  loadComponentModuleLazily(activityTags, () => import("./_init/_activity"));
  loadComponentModuleLazily(reorderTags, () => import("./_init/_reorder"));
  loadComponentModuleLazily(rubricTags, () => import("./_init/_rubrics"));
  loadComponentModuleLazily(lwmTags, () => import("./_init/_lwm"));
  loadComponentModuleLazily(lmsTags, () => import("./_init/_lms"));
  loadComponentModuleLazily(ltiTags, () => import("./_init/_lti"));
  loadComponentModuleLazily(aiTags, () => import("./_init/_ai"));
  loadComponentModuleLazily(ddTags, () => import("./_init/_dd"));
  loadComponentModuleLazily(enrollmentTags, () => import("./_init/_enrollments"));
  loadComponentModuleLazily(panelsTags, () => import("./_init/_panels"));
  loadComponentModuleLazily(programsTags, () => import("./_init/_programs"));
  loadComponentModuleLazily(adminTags, () => import("./_init/_admin"));
  loadComponentModuleLazily(flashcardsTags, () => import("./_init/_flashcards"));
  loadComponentModuleLazily(assessmentTags, () => import("./_init/_assessment"));
  loadComponentModuleLazily(loginTags, () => import("./_init/_login"));
  loadComponentModuleLazily(pluginTags, () => import("./_init/_plugin"));
}

/**
 * Scans document for specific html (web-component) tags, and loads the component files upon detection.
 *
 * WARNING:
 * This only scans Light DOM, web-components nested inside other web-components will not be detected!
 * Therefore, nested components must be either:
 * - manually imported in components that use them
 * - included in the same component module (`./_init/_<module>.ts` and `./_init/_<module>.tags.ts` files)
 */
function loadComponentModuleLazily(
  tags: readonly string[],
  load: () => Promise<unknown>,
) {
  return new MutationObserver((records, observer) => {
    if (!document.querySelector(tags.join(","))) return;

    load()
      .catch((err) => {
        console.error("Failed to load components due to error", err);

        // no way to check why loading failed, assume it's because
        // new version of the app was released and chunks have new ids/names
        document.dispatchEvent(new CustomEvent("jnct:release-reload-modal"));
      });

    observer.disconnect();
  }).observe(document.body, { childList: true, subtree: true });
}
